import React, { useState, useContext, lazy } from "react";
import { AppContext } from "../contexts/App";
import Layout from "../components/Layout";
import { Icon } from "@rmwc/icon";
import SplashScreen from "../components/SplashScreen";
import { Overlay } from 'react-portal-overlay';


// lazy load the core components
//const NearbyPlaces = lazy(() => import("../components/NearbyPlaces"));
const ShareMUGIS = lazy(() =>  import("../components/ShareMUGIS"));
const SearchContent = lazy(() => import("../components/SearchContent"));
const WebMapView = lazy(() => import("../components/WebMapView"));


const Home = () => {
  const { state, setState } = useContext(AppContext);
  const {sidePanelShown} = state;
  
  const toggleSlidePanel = () => {
    setState({ sidePanelShown : !sidePanelShown});
  }
  return <Layout>
    <SearchContent/>
    <ShareMUGIS/>
    <WebMapView/>
    <div id="slide-left-btn" className={(state.mode === "normal") ? (sidePanelShown ? "slide-left-btn slide-left-btn-visible slide-left-btn-hide" : "slide-left-btn slide-left-btn-visible slide-left-btn-show") : "hidden" } onClick={toggleSlidePanel}>
      <div>
        <Icon id="slideIcon" icon={sidePanelShown ? "keyboard_arrow_left": "keyboard_arrow_right"}/>
      </div>
    </div>
  </Layout>;
};
export default Home;
